/**
 * useHonorarvereinbarungTemplates — Honorarvereinbarungs-Vorlagen laden
 * Issue #373 / #314 — Stammdaten für SV-Gutachten-Honorarvereinbarungen
 * (BVSK, HUK, individuell …). Wird vom Dropdown in AuftragSection
 * (AkteDetail) genutzt.
 */

import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { HonorarvereinbarungTemplate } from '@/lib/database.types';

export function useHonorarvereinbarungTemplates() {
  const [data, setData] = useState<HonorarvereinbarungTemplate[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    const { data: rows, error: err } = await supabase
      .from('honorarvereinbarung_templates')
      .select('*')
      .eq('ist_aktiv', true)
      .order('sortierung', { ascending: true })
      .order('label', { ascending: true });
    if (err) {
      setError(err.message);
      setData([]);
    } else {
      setError(null);
      setData((rows ?? []) as HonorarvereinbarungTemplate[]);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, loading, error, refetch: reload };
}
